$(() => {
    //счетчик на повторную отправку телефона 
    if($(".profile-countdown").length){
      $(".profile-countdown").each(function(){
        let countDownMin = $(this).data("countdown");
        var seconds = countDownMin*60+1, h,m,s,t;
        let el = $(this);
        function countDown() {
            if (seconds > 0) {
                    seconds --;
                        h = seconds/3600 ^ 0,
                        m = (seconds-h*3600)/60 ^ 0,
                        s = seconds-h*3600-m*60,
                        time = (m)+":"+(s<10?"0"+s:s);
                        el.text(time);
            }else{
              return false;
            }
            setTimeout(function() {
                countDown();
            }, 1000);
        }
        countDown();
      })

    }

})